import React, { useState, useEffect } from "react";
import { Box, Heading, Button, Layer, Text } from "grommet";
import { Close } from "grommet-icons";
import actions_lp from "../../assets/portfolio_manager/actions_lp.png";
import add_lp from "../../assets/portfolio_manager/add_lp.png";
import actions_courses from "../../assets/portfolio_manager/actions_courses.png";
import add_new_course from "../../assets/portfolio_manager/add_new_course.png";
import add_question from "../../assets/portfolio_manager/add_question.png";
import confirm_add_questions from "../../assets/portfolio_manager/confirm_add_questions.png";
import confirm_skill_mapping from "../../assets/portfolio_manager/confirm_skill_mapping.png";
import course_unpublished from "../../assets/portfolio_manager/course_unpublished.png";
import dashboard from "../../assets/portfolio_manager/dashboard.png";
import edit_question from "../../assets/portfolio_manager/edit_question.png";
import lp_unpublished from "../../assets/portfolio_manager/lp_unpublished.png";
import manage_courses_actions from "../../assets/portfolio_manager/manage_courses_actions.png";
import manage_courses_actions2 from "../../assets/portfolio_manager/manage_courses_actions2.png";
import manage_courses_actions3 from "../../assets/portfolio_manager/manage_courses_actions3.png";
import manage_courses from "../../assets/portfolio_manager/manage_courses.png";
import manage_lp_actions from "../../assets/portfolio_manager/manage_lp_actions.png";
import manage_lp_actions2 from "../../assets/portfolio_manager/manage_lp_actions2.png";
import manage_lp from "../../assets/portfolio_manager/manage_lp.png";
import actions_skill from "../../assets/portfolio_manager/actions_skill.png";
import new_skill_mapping from "../../assets/portfolio_manager/new_skill_mapping.png";
import new_skill from "../../assets/portfolio_manager/new_skill.png";
import publish_changes from "../../assets/portfolio_manager/publish_changes.png";
import publish_changes2 from "../../assets/portfolio_manager/publish_changes2.png";
import questions_for_course from "../../assets/portfolio_manager/questions_for_course.png";
import questions from "../../assets/portfolio_manager/questions.png";
import select_questions_courses from "../../assets/portfolio_manager/select_questions_courses.png";
import skill_ques_mapping from "../../assets/portfolio_manager/skill_ques_mapping.png";
import unpublish_course from "../../assets/portfolio_manager/unpublish_course.png";
import unpublish_questions from "../../assets/portfolio_manager/unpublish_questions.png";
import view_course_add_course from "../../assets/portfolio_manager/view_course_add_course.png";
import view_courses from "../../assets/portfolio_manager/view_courses.png";

const slides = [
  {
    text: "Welcome to the Portfolio Manager Dashboard! This is where you can view all portfolios and their details, including the number of skills, courses, questions, and learning paths. Click on 'View Portfolio' to explore the actions available for each portfolio.",
    image: dashboard,
  },
  {
    text: "On the Actions page you can perform various tasks such as managing learning paths, managing courses, or manage skill questions mapping. You can also get email support through this page or choose to go back to the dashboard using the 'Back to Dashboard' button. Click on 'Manage Learning Paths' to begin managing learning paths.",
    image: actions_lp,
  },
  {
    text: "The 'Manage Learning Paths' page lets you view and manage all learning paths in this portfolio. You can see the number of learning paths, with their status indicated by a status dot: green for published and red for unpublished. The number of courses in each learning path is also shown, categorized by course level: prerequisites, foundational, and intermediate, along with the total course count. To perform actions on a learning path, click the 'Actions' button next to its name. This will display available actions, which we will cover later. To add a new learning path, click on '+ Add Learning Path'.",
    image: manage_lp,
  },
  {
    text: "In the 'Add Learning Path' modal, you can enter a name for the learning path and select course(s) to add to it. If you want to create a new course and add it to this learning path, click on '+ Add New Course', fill in the course details, and select it from the dropdown list to create a new course within the learning path and then finally click on Create to confirm the creation.",
    image: add_lp,
  },
  {
    text: "Upon clicking the 'Actions' button for a learning path, you will see various available actions. These include viewing courses inside the learning path, editing the learning path name, and publishing or unpublishing the learning path. The publish/unpublish button will change depending on the current status of the learning path. Click on 'View Courses' to explore the courses within the learning path.",
    image: manage_lp_actions,
  },
  {
    text: "The 'View Courses' page shows all courses in the learning path. You can view each course's status (Published or Unpublished) and rearrange the order using the up and down icons. You can publish or unpublish courses and add existing courses by clicking '+ Add Existing Course'. To add a new course, click '+ Add New Course', fill in the details, and add it using the 'Add existing course' button. After making changes, click 'Save Changes'. For now, let's click '+ Add Existing Course' to proceed.",
    image: view_courses,
  },
  {
    text: "Inside the 'Add Existing Course' modal, you can select courses from the dropdown list and click on 'Add Selected' to include them in the learning path. After selecting courses, make sure to click 'Save Changes' on the View Courses page to finalize the updates.",
    image: view_course_add_course,
  },
  {
    text: "On clicking the 'Actions' button for a learning path, you can choose between several actions. If the learning path is unpublished, you will see the 'Publish' button; if it is published, you will see the 'Unpublish' button. Clicking on 'Unpublish' will change the learning path's status to unpublished.",
    image: manage_lp_actions2,
  },
  {
    text: "After unpublishing the learning path we could now see the updated status of the path. From published (green dot) to unpublished (red dot). Clicking on the 'Actions' button allows you to select 'Publish' to restore the learning path to its published state. Click next to proceed and learn how to manage courses within the learning path.",
    image: lp_unpublished,
  },
  {
    text: "Click on 'Manage Courses' to start managing courses within the portfolio.",
    image: actions_courses,
  },
  {
    text: "In the 'Manage Courses' section, you can see all courses within your portfolio. You can view the number of courses associated with this portfolio, each course's publishing status, name, mapped skills, number of questions linked to the course, course vendor, duration, and course type (ILT/VILT, eLearning). You can also see whether the course has a prerequisite, foundational, or intermediate weight. Additionally, you have access to the 'Actions' button to manage each course's settings. Click on '+ Add Course' to add a new course.",
    image: manage_courses,
  },
  {
    text: "In the 'Add New Course' modal, you can fill in all the course details, including the course name, code, course mode, skills, vendor, course level, and duration. Once all details are added, click 'Create Course' to finalize the creation of the course.",
    image: add_new_course,
  },
  {
    text: "When you click the 'Actions' button for a course, you can view available actions, such as viewing course questions, viewing the course datasheet, adding questions, and publishing or unpublishing the course depending on the status of the course. Click on 'View Questions' to view the questions associated with the course.",
    image: manage_courses_actions,
  },
  {
    text: "The 'Questions for Course' modal lets you view all questions linked to a particular course. You can see the question text and type. If you want to add more questions, click on 'Add More Questions'. To exit, click 'Close' or click outside the modal.",
    image: questions_for_course,
  },
  {
    text: "In the 'Actions' menu for a course, you can select 'Add Question' to add existing questions.",
    image: manage_courses_actions2,
  },
  {
    text: "The 'Select Questions' modal allows you to choose questions from the portfolio that are not yet linked to this course. You can search for specific questions by text or course name, select the appropriate ones, and click 'Next' to proceed.",
    image: select_questions_courses,
  },
  {
    text: "Under the 'Confirm Add Questions' modal, you can review all the selected questions, including their details such as text, type, and linked course. Once you're sure, click 'Confirm' to finalize adding these questions to the course.",
    image: confirm_add_questions,
  },
  {
    text: "The 'Actions' button for each course lets you choose between actions such as viewing questions, adding questions, and publishing/unpublishing the course. You can unpublish the course by clicking 'Unpublish' to make the course details unavailable to learners.",
    image: manage_courses_actions3,
  },
  {
    text: "In the 'Unpublish Course' modal, you can verify course details, including course code, name, duration, and vendor. Once confirmed, click 'Yes' to unpublish the course and remove it from the active catalog.",
    image: unpublish_course,
  },
  {
    text: "After unpublishing the course, its status will change to unpublished (indicated by a red status dot). To publish it again, click on the 'Actions' button and select 'Publish'. The course will be made available to learners again.",
    image: course_unpublished,
  },
  {
    text: "Click on 'Skill Question Mapping' to manage skill questions across the portfolio.",
    image: actions_skill,
  },
  {
    text: "In the 'Skill Question Mapping' section, you can view the total number of skills associated with this portfolio and the skills present in your portfolio, which includes the status, name, and question distribution (based on difficulty level). You can also see the number of courses linked to each skill. The 'Actions' column lets you view questions for the skill or publish/unpublish the skill as needed. To create a new skill, click on '+ Create New Skill'.",
    image: skill_ques_mapping,
  },
  {
    text: "Under the 'Create New Skill Mapping' modal, you can add a new skill, enter skill name, select the vendor, and choose the courses from which you want to map questions. You'll also see the number of total available questions and number of selected questions. Click 'Submit' to move forward with the creation of the new skill mapping.",
    image: new_skill_mapping,
  },
  {
    text: "In the 'Confirm Skill Mapping' modal, you can review the details of the new skill, including its name, vendor, and the questions selected from various courses. Once you confirm the data, click 'Confirm' to finalize the creation of the new skill mapping.",
    image: confirm_skill_mapping,
  },
  {
    text: "You can view the newly created skill in the Skill Question mapping page, where it will initially appear with an unpublished status. To publish the skill, click on the 'Publish' button in the 'Actions' column. For now, click 'View' to examine the questions linked to the skill.",
    image: new_skill,
  },
  {
    text: "The 'Questions' page provides an overview of all the questions linked to a specific skill. You can see the number of published, unpublished, and total questions for the skill. The page lists all questions with detailed information for each one, including its status (published or unpublished), question text, type (Yes/No or Range), weight (beginner, intermediate, or advanced), and the linked course and learning path. Each question also has an 'Actions' column, where you can edit the question, or publish/unpublish it based on its current status. You can quickly unpublish all published questions in this skill by clicking the 'Unpublish' button or publish all unpublished questions using the 'Publish changes' button. Additionally, you can add new questions to the skill by clicking on the '+ Add Questions' button. For now, let's take a look at how to edit an existing question by clicking on the 'Edit' icon in the actions column next to a question.",
    image: questions,
  },
  {
    text: "In the 'Edit Question' modal, you can modify a question's text, type, and linked course. The learning path will be automatically updated based on the course's learning path linkage. Once done, click 'Submit' to finalize the updates.",
    image: edit_question,
  },
  {
    text: "The 'Unpublish Questions' modal appears when you attempt to unpublish all published questions using the 'Unpublish' button present on the Questions page. It displays the portfolio and skill name along with the number of published questions. Click 'Yes' to unpublish all the questions in that skill.",
    image: unpublish_questions,
  },
  {
    text: "After unpublishing all published questions, their status will change to unpublished (indicated by a red status dot). You can now see the number of published and unpublished questions have changed. Click on 'Publish Changes' to publish all the unpublished questions at once.",
    image: publish_changes,
  },
  {
    text: "Under the 'Publish Changes' modal, you can review the portfolio and skill name, along with the total number of unpublished questions and the list off questions. Once you've reviewed the list of questions, click 'Yes' to publish them all and make them visible to learners.",
    image: publish_changes2,
  },
  {
    text: "In the 'Add Question' section, you can add a new question to the skill. To begin, click on '+ Add Question' from the 'Questions' page. On the 'Add Question' page, you will need to fill in the question text, select the question type (Yes/No or Range), and assign a weight (beginner, intermediate, or advanced). You also need to choose the course and learning path that the question will be associated with. If the course is not already available, you can add a new course by filling in the course details and selecting it from the list. Once you've entered all the required details, you have the option to click 'Cancel' to discard the changes. If you want to add more questions to the same skill, simply click 'Submit & Add Question'. To finish and return to the questions page, click 'Submit & Close' to add the question and exit the page.",
    image: add_question,
  },
];

const QuickStartGuideModal = ({ showModal, setShowModal }) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    if (showModal) {
      setCurrentSlide(0);
    }
  }, [showModal]);

  return (
    showModal && (
      <Layer
        onEsc={() => setShowModal(false)}
        onClickOutside={() => setShowModal(false)}
        responsive={false}
      >
        <Box
          width="80vw" // Set width to 80% of the viewport width
          height="auto"
          pad={{ top: "medium", horizontal: "xsmall" }}
          round="small"
          overflow="auto"
          alignSelf="center"
        >
          <Box
            direction="row"
            align="center"
            margin={{ bottom: "small" }}
            justify="between"
          >
            {/* Step Indicator on the left */}
            <Text size="medium" margin={{ left: "small" }}>
              {`Step ${currentSlide + 1} of ${slides.length}`}
            </Text>

            {/* Title in the center */}
            <Heading
              level={2}
              margin={{ vertical: "none", right: "none", left: "105px" }}
              alignSelf="center"
              textAlign="center" // Center the text
              style={{ flexGrow: 1, display: "flex", justifyContent: "center" }} // Ensure the title is horizontally centered
            >
              Skill Advisor Portfolio Manager Portal Tour
            </Heading>

            {/* Close Button on the right */}
            <Button
              icon={<Close />}
              margin={{ right: "small" }}
              onClick={() => setShowModal(false)}
              plain
              style={{ marginLeft: "auto" }}
            />
          </Box>

          <Box align="center" pad="small" flex="grow" width="100%">
            <img
              src={slides[currentSlide].image}
              alt="Slide Image"
              style={{
                maxWidth: "100%", // Make image take up the full width of the container
                maxHeight: "70vh", // Limit height for readability, but still larger
                objectFit: "contain", // Ensure the image maintains its aspect ratio and fits within the box
              }}
            />
            <Text textAlign="center" margin={{ top: "small" }} size="medium">
              {slides[currentSlide].text}
            </Text>
          </Box>
        </Box>
        <Box pad={{ bottom: "small", horizontal: "medium" }}>
          <Box
            direction="row"
            justify="end"
            margin={{ top: "small" }}
            width="100%"
          >
            {currentSlide > 0 && (
              <Button
                label="Previous"
                onClick={() => setCurrentSlide(currentSlide - 1)}
                secondary
              />
            )}
            {currentSlide < slides.length - 1 ? (
              <Button
                label="Next"
                onClick={() => setCurrentSlide(currentSlide + 1)}
                primary
                margin={{ left: "medium" }}
              />
            ) : (
              <Button
                label="Close"
                onClick={() => setShowModal(false)}
                primary
                margin={{ left: "medium" }}
              />
            )}
          </Box>
        </Box>
      </Layer>
    )
  );
};

export default QuickStartGuideModal;
